export const SET_PAYROLL_RUNS_TABLE_STATE = 'SET_PAYROLL_RUNS_TABLE_STATE';
export const RESET_PAYROLL_RUNS_TABLE_STATE = 'RESET_PAYROLL_RUNS_TABLE_STATE';
export const SET_PAYROLL_RUNS_SELECTED_ROWS = 'SET_PAYROLL_RUNS_SELECTED_ROWS';

export const setPayrollRunsTableState = (queries: any) => ({
  type: SET_PAYROLL_RUNS_TABLE_STATE,
  payload: queries,
});

export const resetPayrollRunsTableState = () => ({
  type: RESET_PAYROLL_RUNS_TABLE_STATE,
});

export const setPayrollRunsSelectedRows = (selectedRows: any) => ({
  type: SET_PAYROLL_RUNS_SELECTED_ROWS,
  payload: selectedRows,
});
